import accountService from "../services/account";
import accoutUser from "../services/account.users";
import notification from "../services/notification";
import _ from "lodash";

export default {
    namespaced: true,

    state: {
        loading: false,
        errors: null,
        detail: {
            uuid: null,
            name: null,
            registration_number: null,
            tin_number: null,
            billing_email: null,
            billing_address: null
        },
        user: {
            firstname: null,
            lastname: null,
            designation: null,
            email: null,
            logo_image: null,
            mobile: null,
            id_number: null,
            uuid: null
        },
        subscriptionDetails: null,
        plan_channels: {},
        plan_executions: {}
    },

    mutations: {
        loading(state, value) {
            state.loading = value;
        },

        errors(state, errors) {
            state.errors = errors;
            state.loading = false;
        },

        setDetail(state, value) {
            state.detail = value;
        },

        setSubscriptionDetails(state, value) {
            state.subscriptionDetails = value;
        },

        setMerchantProfile(state, response) {
            state.detail.uuid = response.uuid;
            state.detail.name = response.companyName;
            state.detail.registration_number = response.registrationNumber;
            state.detail.tin_number = response.tinNumber;
            state.detail.billing_email = response.billingEmail;
            state.detail.billing_address = response.billingAddress;
        },

        setUpdatedMerchantProfile(state, response) {
            state.detail.uuid = response.uuid;
            state.detail.name = response.name;
            state.detail.registration_number = response.registration_number;
            state.detail.tin_number = response.tin_number;
            state.detail.billing_email = response.billingEmail;
            state.detail.billing_address = response.billingAddress;
        },

        setUserProfile(state, response) {
            state.user.firstname = response.firstName;
            state.user.lastname = response.lastName;
            state.user.designation = response.designation;
            state.user.email = response.email;
            state.user.mobile = response.mobileNumber;
            state.user.id_number = response.idNumber;
            state.user.uuid = response.uuid;
            state.user.logo_image = response.image;

            if (response.image != null && response.image != "") {
                if (response.image.search("data:image") == -1) {
                    state.user.logo_image = null;
                } else {
                    state.user.logo_image = response.image.replace(
                        /data:image\/png;base64,/gi,
                        ""
                    );
                }
            }
        },

        setUser(state, response) {
            state.user.uuid = response.uuid;
            state.user.firstname = response.firstName;
            state.user.lastname = response.lastName;
            state.user.mobile = response.mobileNumber;
            state.user.email = response.email;
            state.user.designation = response.designation;
            state.user.id_number = response.idNumber;
        },

        setSubscriptionChannels(state, planDetails) {
            const channels_keys = [
                'enable_glife',
                'enable_estore_web',
                'enable_loyalty_web',
                'enable_customer_app_android',
                'enable_customer_app_ios',
                'enable_widget',
                'enable_api'
            ];
            const collected_channels = {};
            channels_keys.map(key => collected_channels[key] = planDetails[key]);
            state.plan_channels = collected_channels;
        },

        setSubscriptionExecutions(state, planDetails) {
            const execution_keys = [
                'enable_estore',
                'enable_membership_tiering',
                'enable_loyalty',
                'enable_credit_wallet',
                'enable_privilege_card'
            ];
            const collected_exections = {};
            execution_keys.forEach(key => collected_exections[key] = planDetails[key]);
            state.plan_executions = collected_exections;
        }
    },

    getters: {
        getUser() {
            return accountService.getUser();
        },
        getUpdatedProfile(state) {
            return state.detail;
        },
        getUpdatedUserProfile(state) {
            return state.user;
        },
        planDetails: state => state.detail.plan_details ?
            state.detail.plan_details : null,
        planChannels: state => state.plan_channels,
        planExecutions: state => state.plan_executions,
        isEStoreWebChannelEnabled: state => !!state.plan_channels.enable_estore_web,
        isWebChannelEnabled: state => 
          !!state.plan_channels.enable_estore_web || !!state.plan_channels.enable_loyalty_web,
        isAppChannelEnabled: state => 
          !!state.plan_channels.enable_customer_app_android || 
            !!state.plan_channels.enable_customer_app_ios,
        isGLifeChannelEnabled: state =>
          !!state.plan_channels.enable_glife,
        brandLimit: state => _.get(state, "detail.settings.brand_limit", null),
        branchLimit: state => _.get(state, "detail.settings.branch_limit", null),
        liveSubdomain: state => _.get(state, "detail.customer_app_credential[0].subdomain", ""),
        displayAutoLogout: state => _.get(state, "detail.settings.display_auto_logout", false),
        isOfflineCapabilitiesVisible: state => _.get(state, "detail.settings.is_offline_capabilities_enabled", false),
        isPaymentExpressEnabled: state => _.get(state, "detail.settings.is_payment_express_enabled", false),
    },

    actions: {
        assignMerchantDetail: async ({ commit }) => {
            commit("loading", true);
            try {
                let response = await accountService.getDetail();
                commit("setDetail", response);
                commit("setSubscriptionDetails", response.subscription_details);
                commit("setSubscriptionChannels", response.plan_details);
                commit("setSubscriptionExecutions", response.plan_details);
            } catch (errors) {
                commit("errors", errors);
            }
        },

        updateMerchantProfile: async ({ commit, state }) => {
            commit("loading", true);
            try {
                let response = await accountService.updateMerchantProfile(
                    state.detail
                );
                console.log(response);
                // notification.success(response.message);
            } catch (errors) {
                // commit("errors", errors);
            }
        },

        updateUserProfile: async ({ commit, state }) => {
            try {
                let response = await accountService.updateUserProfile(
                    state.user
                );
                state.user = response.user;
            } catch (errors) {
                commit("errors", errors);
            }
        },

        updateAdminProfile: async ({ commit, state }) => {
            commit("loading", true);
            try {
                await accountService.updateMerchantProfile(state.detail);

                let response = await accountService.updateUserProfile(
                    state.user,
                    state.errors = null
                );
                state.user = response.user;
                notification.success("Successfully updated profile");
            } catch (errors) {
                commit("errors", errors);
                notification.warning("Oops, something went wrong");
            }
        },

        updateUser: async ({ commit, state }) => {
            try {
                let response = await accoutUser.updateUser(
                    state.user,
                    state.user.uuid,
                    state.errors = null
                );
                state.user = response.user;
                notification.success(response.message);
            } catch (errors) {
                commit("errors", errors);
            }
        },

        getUserProfile: async ({ commit }) => {
            try {
                return await accountService.getUser();
            } catch (errors) {
                commit("errors", errors);
            }
        },

        setLoading: async ({ commit }, value) => {
            try {
                commit("loading", value);
            } catch (errors) {
                commit("errors", errors);
            }
        }
    }
};
